<template>
    <div class="app-loader">
        <div class='spinner'>
            <div class='dot'></div>
            <div class='dot'></div>
            <div class='dot'></div>
            <div class='dot'></div>
        </div>
    </div>
</template>
<script>
export default {  
}
</script>